import {
  ReactElement
} from "react";
// import { LogoDark } from "../../assets";
import { Logout, MiniLogo , Size, } from "../../assets";
import HeaderItem from "./header_item";
import { Box, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { menuItems } from "../../core/utils";
import routes from "../../core/routes";
//
interface IMyProps {
  handleDrawerOpen: any;
  userData?: any

}



export function MiniHeader({ handleDrawerOpen ,userData}: IMyProps): ReactElement {

  return (
    <div className="mini-header">
  <Link to="/">
      <div className="mini-header-logo">
        <img alt="هامرز" src={MiniLogo} className="w-100" />
      </div>
      </Link>
      <div>
      <div className="mini-header-border">

</div>
        {menuItems?.filter(item => {
    if (item.path === routes.CONSULTATION) {
      return (userData?.national_code === "2710067587" || userData?.national_code === "2269978811");
    }
    return true;
  })?.map((item, index) => {
          return (
            <Tooltip
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "#155a9e",
                  '& .MuiTooltip-arrow': {
                    color: "#155a9e",
                  },
                },
              },
            }}
            title={item?.name}>
            <Box key={index}>
              <HeaderItem
                myStyle="header-item-mini"
                icon={item?.icon}
                link={item.path}
              />
            </Box>
          </Tooltip>
          )
        })}
      </div>

      <div>
<div className="mini-header-border">

</div>

        <div className="cursor-pointer" onClick={handleDrawerOpen}>
          <img alt="هامرز" src={Size} className="ps-1 mb-3" />
        </div>
        <div className="cursor-pointer" >
          <img alt="هامرز" src={Logout} className="ps-1" />
        </div>
      </div>


    </div>
  );
}
export default MiniHeader;
